module.exports = __webpack_public_path__ + "img/8a5a306.png";